import { render, staticRenderFns } from "./MainInfoColumn.vue?vue&type=template&id=bb65022a&scoped=true&"
import script from "./MainInfoColumn.vue?vue&type=script&lang=js&"
export * from "./MainInfoColumn.vue?vue&type=script&lang=js&"
import style0 from "./MainInfoColumn.vue?vue&type=style&index=0&id=bb65022a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb65022a",
  null
  
)

export default component.exports